var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-container",class:{'basic-container--block':_vm.block}},[_c('el-card',{attrs:{"shadow":"never"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }